import { Box, Grid, Typography } from '@mui/material'
import React, { Fragment } from 'react'
import { UseFormReturn } from 'react-hook-form'
import { useStyles } from './styles'

interface IValidationProps {
  formData: UseFormReturn<any>
}

const Validation: React.FC<IValidationProps> = ({ formData: { watch } }) => {
  const classes = useStyles()

  return (
    <>
      <Typography variant='h6'>
        E por ultimo as configurações de logo e cores que foram escolhidos (#FFFFFF)
      </Typography>

      <Box className={classes.contentBox}>
        <Typography variant='h6' sx={{ margin: '1rem 0' }}>
          Logos
        </Typography>
        <Grid container className={classes.itemBox}>
          <Grid item xs={6}>
            <Box className={classes.logoBox}>
              <img src={watch('baseLogo')} alt='base logo' />
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Box className={classes.logoBoxBlack}>
              <img src={watch('whiteLogo')} alt='white logo' />
            </Box>
          </Grid>
        </Grid>
      </Box>

      <Box className={classes.contentBox}>
        <Typography variant='h6' sx={{ margin: '1rem 0' }}>
          Cores
        </Typography>
        <Grid container className={classes.itemBox}>
          <Grid item xs={4}>
            <Box className={classes.colorBox} bgcolor={`#${watch('primaryColor')}`} />
            <span>Primaria</span>
          </Grid>
          <Grid item xs={4}>
            <Box className={classes.colorBox} bgcolor={`#${watch('secondaryColor')}`} />
            <span>Secundaria</span>
          </Grid>
          <Grid item xs={4}>
            <Box className={classes.colorBox} bgcolor={`#${watch('terciaryColor')}`} />
            <span>Terciária</span>
          </Grid>
        </Grid>
      </Box>
    </>
  )
}

export default Validation
